import cnst from '@/const/const'

const getters = {
  showLoading: (state) => state.showLoading,
}

const mutations = {
  [cnst.SHOW_LOADING](state, value) {
    state.showLoading = value
  },
}

const state = {
  showLoading: false,
}

export default {
  state,
  getters,
  mutations,
}
